
const handleApiErr = (err:any) => {
    if(err.status===500 || err?.message?.includes('Network Error') || err.status=== 403 || err.status=== 401){
        return false
    }
    return true
};
export default handleApiErr;
